import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTestBuyTag = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 21,
	fill: "none",
	viewBox: "0 0 21 21",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#111",
		d: "M8 8a1.5 1.5 0 1 0-2-2 1.5 1.5 0 0 0 2 2Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "m2.2 2.2-1.3 8 10.4 10.3 9.2-9.2L10.1 1 2.2 2.2Zm9.1 15.5L3.1 9.4 4 4l5.4-1 8.3 8.3-6.4 6.4Z",
		clipRule: "evenodd"
	})]
});
export default SvgTestBuyTag;
